import React from "react";
import Icon from "../../../icons";
import LoaderComponent from "../../Loader";
import Address from "../FormComponent/address";

const BusinessLocationSection = ({
  updatingData,
  isEditing,
  orgProfileUIData,
  orgProfileInfo,
  onEditClick,
  closeEditField,
  updateBusinessLocation,
  setInputChange,
  inputChange,
  getOrgLocationByZip,
  zipLocSuggestion,
}) => {
  let content;

  if (updatingData === "businessLocation") {
    content = <LoaderComponent />;
  } else if (isEditing) {
    content = (
      <Address
        selectedCountry={orgProfileInfo?.DisplayCountry}
        addressInfo={{
          Address1: orgProfileUIData?.Address1,
          Address2: orgProfileUIData?.Address2 || "",
          City: orgProfileUIData?.City,
          Zip: orgProfileUIData?.Zip,
          State: orgProfileUIData?.State,
          County: orgProfileUIData?.County,
        }}
        getlocationByZip={(payload) => getOrgLocationByZip(payload)}
        zipLocSuggestion={zipLocSuggestion}
        closeEditField={() => closeEditField("businessLocation")}
        updateBusinessLoc={(payload) => updateBusinessLocation(payload)}
        updateInputchange={(data) => setInputChange(data)}
        inputChange={inputChange}
      />
    );
  } else {
    content = (
      <span className="gridOdd col-md-9">
        {orgProfileUIData?.Address1 && (
          <div className="alignMiddle">
            <div className="profile-settings__address">
              {orgProfileUIData.Address1}
              {orgProfileUIData?.Address2 && (
                <>
                  {orgProfileUIData.Address2}
                  <br />
                </>
              )}
              {`${orgProfileUIData?.City}, ${orgProfileUIData?.State} ${orgProfileUIData?.Zip}`}
              <br />
              <strong>{orgProfileUIData?.DisplayCountry}</strong>
              <span className="profile-settings__address__icon statusCheck">
                <button
                  type="button"
                  className="icon ml__1 editDetail btn-cc btn-cc__transparent"
                  onClick={() =>
                    onEditClick({
                      id: "businessLocation",
                      value: orgProfileUIData?.Country,
                    })
                  }
                  data-test="details editBusinessLocation"
                  aria-label="Edit business location"
                >
                  <Icon name="editActive" className="icon" />
                </button>
              </span>
            </div>
          </div>
        )}
      </span>
    );
  }

  return (
      content
  );
};

export default BusinessLocationSection;
